<mat-card class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block">

  <mat-card-header>
    <mat-card-title class="d-flex align-items-center gap-3 d-flex">
      <form class="search-box position-relative">
        <i class="material-symbols-outlined">search</i>
        <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
               placeholder="Chercher un produit"
               (keyup)="applyFilter($event)">
      </form>
      
      <form class="search-box position-relative">
        <i class="material-symbols-outlined">search</i>
        <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
               placeholder="Chercher un pesticide"
               (keyup)="applyPesticideFilter($event)">
      </form>
      

    </mat-card-title>
    <mat-card-subtitle>

        <button type="button" class="btn btn-primary btn-sm rounded-pill border-0 position-relative"
                (click)="refreshProductPesticideData()">
                <span class="px-2">Mise à jour</span>
        </button>
    </mat-card-subtitle>
</mat-card-header>
  
  
  <mat-card-content>
    <div class="recent-orders-table">
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 w-100 custom-table">

          <!-- Définition des colonnes -->
          <ng-container matColumnDef="productName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom du produit</th>
            <td mat-cell *matCellDef="let element">{{ element.productName }}</td>
          </ng-container>
        
          <ng-container matColumnDef="productCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Code du produit</th>
            <td mat-cell *matCellDef="let element">{{ element.productCode }}</td>
          </ng-container>
        
          <ng-container matColumnDef="pesticideName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom du pesticide</th>
            <td mat-cell *matCellDef="let element">
              <div class="pesticide-cell">
                <div *ngFor="let pesticide of element.pesticides" class="pesticide-line">
                  {{ pesticide.pesticideResidueName }}
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="mrlValue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Valeur MRL</th>
            <td mat-cell *matCellDef="let element">
              <div class="pesticide-cell">
                <div *ngFor="let pesticide of element.pesticides" class="pesticide-line">
                  {{ pesticide.mrlValueOnly }}
                </div>
              </div>
            </td>
          </ng-container>
          
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        

        <!-- Pagination -->
        <mat-paginator [pageSize]="2" [pageSizeOptions]="[2, 5, 10]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>
